module.exports = __webpack_public_path__ + "img/arrow-up.180eced3.svg";